import { SolarScreenMap } from '~/machines/solar-funnel/screen-map';
import { ScreenMapCopy } from '~/machines/utils/types';
import { CredentialsContext, CredentialsCopy } from '~/screens/credentials';

// ucb-specific copy for the credentials screen
export const copy: ScreenMapCopy<SolarScreenMap> = {
  enrollment: {
    utilityConnect: (context: CredentialsContext): Partial<CredentialsCopy> => ({
      description: `We need your utility information to understand your energy usage and maximize your savings. We're not replacing ${context.utility.displayName}. Nothing changes about how you pay your bill. And don't worry, we use industry-standard encryption to keep your data safe and secure.`,
    }),
  },
};
